// store/slices/blocksSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  createBlock,
  getBlock,
  fetchBlocksByClient,
  updateBlock,
  deleteBlock,
} from "../thunks/blocksThunk";

const initialState = {
  block: null,
  clientBlocks: [],
  loadingClientBlocks: false,
  loadingBlock: false,
  error: null,
  warnings: [],
};

const blocksSlice = createSlice({
  name: "blocks",
  initialState,
  reducers: {
    clearBlockState: (state) => {
      state.block = null;
      state.warnings = [];
      state.loading = false;
      state.error = null;
    },
    clearClientBlocks: (state) => {
      state.clientBlocks = []; // Clear client blocks explicitly when needed
    },
  },
  extraReducers: (builder) => {
    builder
      // Create Block
      .addCase(createBlock.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.warnings = [];
      })
      .addCase(createBlock.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.block = action.payload.block || null;
        state.warnings = action.payload.warnings || [];
      })
      .addCase(createBlock.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })

      // Get Block
      .addCase(getBlock.pending, (state) => {
        state.loadingBlock = true;
        state.error = null;
      })
      .addCase(getBlock.fulfilled, (state, action) => {
        state.loadingBlock = false;
        state.error = null;
        state.block = action.payload || null;
      })
      .addCase(getBlock.rejected, (state, action) => {
        state.loadingBlock = false;
        state.error = action.payload || action.error.message;
      })

      // Fetch Blocks by Client
      .addCase(fetchBlocksByClient.pending, (state) => {
        state.loadingClientBlocks = true;
        state.error = null;
      })
      .addCase(fetchBlocksByClient.fulfilled, (state, action) => {
        state.loadingClientBlocks = false;
        state.error = null;
        state.clientBlocks = action.payload ? [...action.payload] : [];
      })
      .addCase(fetchBlocksByClient.rejected, (state, action) => {
        state.loadingClientBlocks = false;
        state.error = action.payload || action.error.message;
      })

      // Update Block
      .addCase(updateBlock.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateBlock.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.block = action.payload || null;
      })
      .addCase(updateBlock.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })

      // Delete Block
      .addCase(deleteBlock.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteBlock.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
        state.block = null;
      })
      .addCase(deleteBlock.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const { clearBlockState, clearClientBlocks } = blocksSlice.actions;
export default blocksSlice.reducer;
